module.exports = __webpack_public_path__ + "static/AstridLoboGajiwalaPhDINDIA-2ba717360fd76964dac2ebb58f46074b.jpg";